// App entry: shell (header + bottom nav), router wiring for all pages.

import './ui/styles.css';
import { Router } from './ui/page';
import { el } from './ui/components';
import { state } from './ui/store';
import { tuningPage } from './ui/pages/tuning';
import { practicePage } from './ui/pages/practice';
import { timbrePage } from './ui/pages/timbre';
import { scorePage } from './ui/pages/score';
import { reportPage } from './ui/pages/report';
import { settingsPage } from './ui/pages/settings';

interface NavItem { route: string; icon: string; label: string; }

const NAV: NavItem[] = [
  { route: '/tuning', icon: '🎯', label: '调音' },
  { route: '/practice', icon: '🎵', label: '练习' },
  { route: '/timbre', icon: '🌈', label: '音色' },
  { route: '/score', icon: '🎼', label: '乐谱' },
  { route: '/report', icon: '📊', label: '报告' },
];

function buildShell(): { content: HTMLElement } {
  const app = document.getElementById('app')!;
  app.innerHTML = '';

  const header = el('div', { style: 'display:flex;align-items:center;justify-content:space-between;padding:12px 16px 0' }, [
    el('div', { style: 'font-weight:700;font-size:16px' }, [el('span', { text: '🎻 ' }), el('span', { text: 'ViolinLab' })]),
    el('div', { class: 'row', style: 'gap:8px' }, [
      onlineDot(),
      gearBtn(),
    ]),
  ]);

  const content = el('main', { class: 'page' });
  const nav = el('nav', { class: 'nav' });
  for (const item of NAV) {
    const b = el('button', {});
    b.setAttribute('data-route', item.route);
    b.append(el('span', { class: 'ico', text: item.icon }), el('span', { text: item.label }));
    b.onclick = () => { location.hash = '#' + item.route; };
    nav.append(b);
  }
  app.append(header, content, nav);
  return { content };
}

function onlineDot(): HTMLElement {
  const dot = el('span', { class: 'tiny', style: 'color:var(--text-faint)', text: state.online ? '🟢' : '🔴' });
  state.subscribe(() => { dot.textContent = state.online ? '🟢' : '🔴'; });
  return dot;
}

function gearBtn(): HTMLElement {
  const b = el('button', { class: 'ghost', style: 'padding:6px 10px;font-size:16px', text: '⚙️' });
  b.onclick = () => { location.hash = '#/settings'; };
  return b;
}

const { content } = buildShell();
const router = new Router(content);
router.add('/tuning', tuningPage);
router.add('/practice', practicePage);
router.add('/timbre', timbrePage);
router.add('/score', scorePage);
router.add('/report', reportPage);
router.add('/settings', settingsPage);
router.start();
